import { useEffect, useState } from "react";
import styled from "styled-components";
import media from "styled-media-query";
import { Text, ColorV2, Button } from "@adoptaunabuelo/react-components";
import VideoModal from "../../../components/modal/VideoModal";
import { useSelector } from "react-redux";
import { State } from "../../../redux";
import { useNavigate } from "react-router";
import { Play } from "lucide-react";
import { AdviceScheme } from "client-v2";

import ContainerSection from "../../../components/landing/ContainerSection";

const DataView = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	z-index: 1;
	justify-content: center;
	${media.lessThan("medium")`
		flex: 0;
        margin: 72px 0px 72px;
    `}
`;
const VideoView = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	z-index: 1;
	justify-content: center;
	align-items: center;
	${media.lessThan("medium")`
        margin-top: 8px;
    `}
`;
const VideoThumb = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: flex-end;
	background-color: white;
	border-radius: 16px;
	aspect-ratio: 9/16;
	max-width: 350px;
	width: 350px;
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	cursor: pointer;
	${media.lessThan("medium")`
		max-width: 100%;
        width: unset;
        height: 100%;
    `}
`;
const PlayButton = styled.div`
	display: flex;
	width: 24px;
	height: 24px;
	padding: 8px;
	justify-content: center;
	align-items: center;
	flex-shrink: 0;
	border-radius: 56px;
	background: rgba(0, 29, 61, 0.14);
	backdrop-filter: blur(20px);
	margin: 16px;
`;

const Header = (props: Props) => {
	const navigate = useNavigate();
	const isMobile = useSelector((state: State) => state.screen.isMobile);
	const [play, setPlay] = useState(false);

	useEffect(() => {
		const timer = setTimeout(() => {
			setPlay(true);
		}, 1000);
		return () => clearTimeout(timer);
	}, []);

	const onVideoEnd = () => {
		setPlay(false);
	};

	return (
		<>
			<VideoModal
				isVisible={play}
				url={props.advice.video}
				onFinish={onVideoEnd}
				onClose={() => setPlay(false)}
			/>
			<ContainerSection
				style={{ backgroundColor: props.advice.grandpa.color }}
			>
				<DataView>
					<Text
						type="h1"
						weight="semibold"
						style={{
							marginBottom: isMobile ? 16 : 32,
						}}
					>
						Con tu apoyo, podemos dar voz y acompañar a más personas
						mayores
					</Text>
					<Text
						type="h6"
						style={{
							marginBottom: isMobile ? 0 : 48,
						}}
					>
						Te invitamos a que formes parte de la Fundación Adopta
						Un Abuelo como embajador para que sigamos mejorando la
						vida de las personas mayores y construyendo entre todos
						una sociedad más inclusiva.
					</Text>
					<Button
						style={{
							width: isMobile ? "100%" : "fit-content",
							backgroundColor: ColorV2.surface.primaryHard,
							display: isMobile ? "none" : "flex",
						}}
						onClick={() => navigate("/consejo/registro")}
					>
						Quiero ser embajador
					</Button>
				</DataView>
				<VideoView>
					<div>
						<VideoThumb
							style={{
								backgroundImage: `url(${props.advice.grandpa.image})`,
							}}
							onClick={() => setPlay(true)}
						>
							<PlayButton>
								<Play
									height={20}
									width={20}
									color="white"
									fill="white"
								/>
							</PlayButton>
						</VideoThumb>
						<Text
							type="c1"
							style={{
								color: ColorV2.text.neutralMedium,
								marginTop: 4,
								textAlign: "right",
							}}
						>
							Escucha el súper consejo de{" "}
							{props.advice.grandpa.name}
						</Text>
					</div>
				</VideoView>
			</ContainerSection>
		</>
	);
};
export default Header;
export interface Props {
	advice: AdviceScheme;
}
